var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgLead = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "24px",
    viewBox: "0 0 27 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "lead icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lead-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 2.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1490753,18 C-0.144178143,18 -0.908595957,15.6666667 1.38465749,13.3333333 C2.91349311,11.7777778 4.95194062,11 7.5,11 L7.5,11 C10.0480594,11 12.0865069,11.7777778 13.6153425,13.3333333 C15.908596,15.6666667 15.1441781,18 12.8509247,18 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: 21,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: 21,
    y: 8,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: 21,
    y: 16,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 5.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-33",
    strokeLinejoin: "round",
    points: "21 2 18 2 18 18 21 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 10,
    x2: 15,
    y2: 10,
    id: "Path-6",
    strokeLinecap: "round"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLead, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lead.254cbe10.svg";
export { ForwardRef as ReactComponent };